import { Component, Input } from '@angular/core';
import FinSupplierCardDTO from 'src/app/invopay/interfaces/fin-supplier-card-dto';

@Component({
  selector: 'app-fn-card-data',
  templateUrl: './fn-card-data.component.html',
  styleUrls: ['./fn-card-data.component.scss']
})
export class FnCardDataComponent {
  @Input() cardInfo?: FinSupplierCardDTO;
  @Input() hideCardNumber: boolean = true;
  showCompleteCardNumber: boolean = false;

  constructor() { }

  formatCardNumber(cardNumber: string): string {
    const cardNumberParts = [];
    for (let i = 0, j = 0; i < 4; i++) {
      cardNumberParts[i] = cardNumber.substring(j, j + 4);
      j += 4;
    }
    let formattedNumber = '';
    if (this.showCompleteCardNumber) {
      cardNumberParts.forEach((part, index) => {
        if (index < 3) {
          formattedNumber += part + ' ';
        }
        else {
          formattedNumber += part;
        }
      });
    }
    else {
      formattedNumber = '**** ' + cardNumberParts[3]
    }
    return formattedNumber;
  }

  switchShowCompleteCardNumber() {
    this.showCompleteCardNumber = !this.showCompleteCardNumber;
  }
}
